module.exports = __webpack_public_path__ + "media/Images/icon-data-d945dd0172faf9506cd1a21085cb4ee5.svg";